import { Action, Reducer } from "redux";
const uuidv4 = require("uuid/v4");
const correlationId = uuidv4();
const versionNumber = "4.0";

export interface GeneralState {
  isVerifyInformationModal: boolean;
  isOffline: boolean;
  pageTitle: string;
  sofViewRejection: boolean;
  versionNumber: string;
  correlationId: string;
  //Marine user roles
  isMarineEditActivityAllowed: boolean;
  isMarineEditTimestampAllowed: boolean;
  isMarineAddCommentAllowed: boolean;
  isMarineDeleteCommentAllowed: boolean;
  isMarineUndoExtendedAllowed: boolean;
  isMarineEditETAAllowed: boolean;
  isMarineRejectLineHandlingAllowed: boolean;
  isMarineUploadFileAllowed: boolean;
  isMarineProcessDWPAllowed: boolean;
  isMarineDeliveryTruckOnly: boolean;
  isMarineProcessAdditionalServices: boolean;
  isMarineApproveLineHandlingAllowed: boolean;
  marineSalesOrg: string;
  //Truck user roles
  isTruckEditActivityAllowed: boolean;
  isTruckEditTimestampAllowed: boolean;
  isTruckAddCommentAllowed: boolean;
  isTruckDeleteCommentAllowed: boolean;
  isTruckUndoExtendedAllowed: boolean;
  isTruckUploadFileAllowed: boolean;
  isTruckProcessDWPAllowed: boolean;
  isTruckProcessAdditionalServices: boolean;
  isTruckApproveRejectionAllowed: boolean;
  isTruckUpdateAssignmentAllowed: boolean;
  truckSalesOrg: string;
}

export const defaultState: GeneralState = {
  isVerifyInformationModal: false,
  isOffline: false,
  correlationId,
  pageTitle: "",
  sofViewRejection: false,
  versionNumber,
  isMarineEditActivityAllowed: false,
  isMarineEditTimestampAllowed: false,
  isMarineAddCommentAllowed: false,
  isMarineDeleteCommentAllowed: false,
  isMarineUndoExtendedAllowed: false,
  isMarineEditETAAllowed: false,
  isMarineRejectLineHandlingAllowed: false,
  isMarineUploadFileAllowed: false,
  isMarineProcessDWPAllowed: false,
  isMarineDeliveryTruckOnly: false,
  isMarineProcessAdditionalServices: false,
  isMarineApproveLineHandlingAllowed: false,
  marineSalesOrg: "",
  isTruckEditActivityAllowed: false,
  isTruckEditTimestampAllowed: false,
  isTruckAddCommentAllowed: false,
  isTruckDeleteCommentAllowed: false,
  isTruckUndoExtendedAllowed: false,
  isTruckUploadFileAllowed: false,
  isTruckProcessDWPAllowed: false,
  isTruckProcessAdditionalServices: false,
  isTruckApproveRejectionAllowed: false,
  isTruckUpdateAssignmentAllowed: false,
  truckSalesOrg: ""
};

export interface SetVerifyInformationAction {
  type: "SET_VERIFY_INFORMATION";
  isVerifyInformationModal: boolean;
}

export interface SetOnlineStationAction {
  type: "SET_ONLINE_STATUS";
  isOffline: boolean;
}

export interface SetPageTitleAction {
  type: "SET_PAGE_TITLE";
  pageTitle: string;
}

export interface CheckSofViewRejectionAction {
  type: "SET_CHECK_SOF_REJECTION";
  sofViewRejection: boolean;
}

export interface SetMarineEditActivityAllowedAction {
  type: "SET_MARINE_EDIT_ACTIVITY_ALLOWED";
  isMarineEditActivityAllowed: boolean;
}

export interface SetMarineEditTimestampAllowedAction {
  type: "SET_MARINE_EDIT_TIMESTAMP_ALLOWED";
  isMarineEditTimestampAllowed: boolean;
}

export interface SetMarineAddCommentAllowedAction {
  type: "SET_MARINE_ADD_COMMENT_ALLOWED";
  isMarineAddCommentAllowed: boolean;
}

export interface SetMarineDeleteCommentAllowedAction {
  type: "SET_MARINE_DELETE_COMMENT_ALLOWED";
  isMarineDeleteCommentAllowed: boolean;
}

export interface SetMarineUndoExtendedAllowedAction {
  type: "SET_MARINE_UNDO_EXTENDED_ALLOWED";
  isMarineUndoExtendedAllowed: boolean;
}

export interface SetMarineEditETAAllowedAction {
  type: "SET_MARINE_EDIT_ETA_ALLOWED";
  isMarineEditETAAllowed: boolean;
}

export interface SetMarineRejectLineHandlingAllowedAction {
  type: "SET_MARINE_REJECT_LINEHANDLING_ALLOWED";
  isMarineRejectLineHandlingAllowed: boolean;
}

export interface SetMarineUploadFileAllowedAction {
  type: "SET_MARINE_UPLOAD_FILE_ALLOWED";
  isMarineUploadFileAllowed: boolean;
}

export interface SetMarineProcessDWPAllowedAction {
  type: "SET_MARINE_PROCESS_DWP_ALLOWED";
  isMarineProcessDWPAllowed: boolean;
}

export interface SetMarineProcessDWPTruckOnlyAction {
  type: "SET_MARINE_PROCESS_DWP_TRUCK_ONLY";
  isMarineDeliveryTruckOnly: boolean;
}

export interface SetMarineProcessAdditionalServicesAction {
  type: "SET_MARINE_PROCESS_ADDITIONAL_SERVICES";
  isMarineProcessAdditionalServices: boolean;
}

export interface SetMarineApproveLineHandlingAllowedAction {
  type: "SET_MARINE_APPROVE_LINEHANDLING_ALLOWED";
  isMarineApproveLineHandlingAllowed: boolean;
}

export interface SetMarineSalesOrgAction {
  type: "SET_MARINE_SALES_ORG";
  marineSalesOrg: string;
}

export interface SetTruckEditActivityAllowedAction {
  type: "SET_TRUCK_EDIT_ACTIVITY_ALLOWED";
  isTruckEditActivityAllowed: boolean;
}

export interface SetTruckEditTimestampAllowedAction {
  type: "SET_TRUCK_EDIT_TIMESTAMP_ALLOWED";
  isTruckEditTimestampAllowed: boolean;
}

export interface SetTruckAddCommentAllowedAction {
  type: "SET_TRUCK_ADD_COMMENT_ALLOWED";
  isTruckAddCommentAllowed: boolean;
}

export interface SetTruckDeleteCommentAllowedAction {
  type: "SET_TRUCK_DELETE_COMMENT_ALLOWED";
  isTruckDeleteCommentAllowed: boolean;
}

export interface SetTruckUndoExtendedAllowedAction {
  type: "SET_TRUCK_UNDO_EXTENDED_ALLOWED";
  isTruckUndoExtendedAllowed: boolean;
}

export interface SetTruckUploadFileAllowedAction {
  type: "SET_TRUCK_UPLOAD_FILE_ALLOWED";
  isTruckUploadFileAllowed: boolean;
}

export interface SetTruckProcessDWPAllowedAction {
  type: "SET_TRUCK_PROCESS_DWP_ALLOWED";
  isTruckProcessDWPAllowed: boolean;
}

export interface SetTruckProcessAdditionalServicesAction {
  type: "SET_TRUCK_PROCESS_ADDITIONAL_SERVICES";
  isTruckProcessAdditionalServices: boolean;
}

export interface SetTruckApproveRejectionAllowedAction {
  type: "SET_TRUCK_APPROVE_REJECTION_ALLOWED";
  isTruckApproveRejectionAllowed: boolean;
}

export interface SetTruckUpdateAssignmentAllowedAction {
  type: "SET_TRUCK_UPDATE_ASSIGNMENT_ALLOWED";
  isTruckUpdateAssignmentAllowed: boolean;
}

export interface SetTruckSalesOrgAction {
  type: "SET_TRUCK_SALES_ORG";
  truckSalesOrg: string;
}

type KnownAction =
  | SetVerifyInformationAction
  | SetOnlineStationAction
  | SetPageTitleAction
  | CheckSofViewRejectionAction
  | SetMarineEditActivityAllowedAction
  | SetMarineEditTimestampAllowedAction
  | SetMarineAddCommentAllowedAction
  | SetMarineDeleteCommentAllowedAction
  | SetMarineUndoExtendedAllowedAction
  | SetMarineEditETAAllowedAction
  | SetMarineRejectLineHandlingAllowedAction
  | SetMarineUploadFileAllowedAction
  | SetMarineProcessDWPAllowedAction
  | SetMarineProcessDWPTruckOnlyAction
  | SetMarineProcessAdditionalServicesAction
  | SetMarineApproveLineHandlingAllowedAction
  | SetMarineSalesOrgAction
  | SetTruckEditActivityAllowedAction
  | SetTruckEditTimestampAllowedAction
  | SetTruckAddCommentAllowedAction
  | SetTruckDeleteCommentAllowedAction
  | SetTruckUndoExtendedAllowedAction
  | SetTruckUploadFileAllowedAction
  | SetTruckProcessDWPAllowedAction
  | SetTruckProcessAdditionalServicesAction
  | SetTruckApproveRejectionAllowedAction
  | SetTruckUpdateAssignmentAllowedAction
  | SetTruckSalesOrgAction;

export const actionCreators = {
  setVerifyInformation: (isVerifyInformationModal: boolean) => ({
    type: "SET_VERIFY_INFORMATION",
    isVerifyInformationModal
  }),

  setOfflineStatus: (isOffline: boolean) => ({
    type: "SET_ONLINE_STATUS",
    isOffline
  }),

  setPageTitle: (pageTitle: string) => ({
    type: "SET_PAGE_TITLE",
    pageTitle
  }),

  checkSofViewRejection: (sofViewRejection: boolean) => ({
    type: "SET_CHECK_SOF_REJECTION",
    sofViewRejection
  }),

  setMarineEditActivityAllowed: (isMarineEditActivityAllowed: boolean) => ({
    type: "SET_MARINE_EDIT_ACTIVITY_ALLOWED",
    isMarineEditActivityAllowed
  }),
  setMarineEditTimestampAllowed: (isMarineEditTimestampAllowed: boolean) => ({
    type: "SET_MARINE_EDIT_TIMESTAMP_ALLOWED",
    isMarineEditTimestampAllowed
  }),
  setMarineAddCommentAllowed: (isMarineAddCommentAllowed: boolean) => ({
    type: "SET_MARINE_ADD_COMMENT_ALLOWED",
    isMarineAddCommentAllowed
  }),
  setMarineDeleteCommentAllowed: (isMarineDeleteCommentAllowed: boolean) => ({
    type: "SET_MARINE_DELETE_COMMENT_ALLOWED",
    isMarineDeleteCommentAllowed
  }),
  setMarineUndoExtendedAllowed: (isMarineUndoExtendedAllowed: boolean) => ({
    type: "SET_MARINE_UNDO_EXTENDED_ALLOWED",
    isMarineUndoExtendedAllowed
  }),
  setMarineEditETAAllowed: (isMarineEditETAAllowed: boolean) => ({
    type: "SET_MARINE_EDIT_ETA_ALLOWED",
    isMarineEditETAAllowed
  }),
  setMarineRejectLineHandlingAllowed: (
    isMarineRejectLineHandlingAllowed: boolean
  ) => ({
    type: "SET_MARINE_REJECT_LINEHANDLING_ALLOWED",
    isMarineRejectLineHandlingAllowed
  }),
  setMarineUploadFileAllowed: (isMarineUploadFileAllowed: boolean) => ({
    type: "SET_MARINE_UPLOAD_FILE_ALLOWED",
    isMarineUploadFileAllowed
  }),
  setMarineProcessDWPAllowed: (isMarineProcessDWPAllowed: boolean) => ({
    type: "SET_MARINE_PROCESS_DWP_ALLOWED",
    isMarineProcessDWPAllowed
  }),
  setMarineProcessDWPTruckOnly: (isMarineDeliveryTruckOnly: boolean) => ({
    type: "SET_MARINE_PROCESS_DWP_TRUCK_ONLY",
    isMarineDeliveryTruckOnly
  }),
  setMarineProcessAdditionalServices: (
    isMarineProcessAdditionalServices: boolean
  ) => ({
    type: "SET_MARINE_PROCESS_ADDITIONAL_SERVICES",
    isMarineProcessAdditionalServices
  }),
  setApproveLineHandlingAllowed: (
    isMarineApproveLineHandlingAllowed: boolean
  ) => ({
    type: "SET_MARINE_APPROVE_LINEHANDLING_ALLOWED",
    isMarineApproveLineHandlingAllowed
  }),
  setMarineSalesOrg: (marineSalesOrg: string) => ({
    type: "SET_MARINE_SALES_ORG",
    marineSalesOrg
  }),
  setTruckEditActivityAllowed: (isTruckEditActivityAllowed: boolean) => ({
    type: "SET_TRUCK_EDIT_ACTIVITY_ALLOWED",
    isTruckEditActivityAllowed
  }),
  setTruckEditTimestampAllowed: (isTruckEditTimestampAllowed: boolean) => ({
    type: "SET_TRUCK_EDIT_TIMESTAMP_ALLOWED",
    isTruckEditTimestampAllowed
  }),
  setTruckAddCommentAllowed: (isTruckAddCommentAllowed: boolean) => ({
    type: "SET_TRUCK_ADD_COMMENT_ALLOWED",
    isTruckAddCommentAllowed
  }),
  setTruckDeleteCommentAllowed: (isTruckDeleteCommentAllowed: boolean) => ({
    type: "SET_TRUCK_DELETE_COMMENT_ALLOWED",
    isTruckDeleteCommentAllowed
  }),
  setTruckUndoExtendedAllowed: (isTruckUndoExtendedAllowed: boolean) => ({
    type: "SET_TRUCK_UNDO_EXTENDED_ALLOWED",
    isTruckUndoExtendedAllowed
  }),
  setTruckUploadFileAllowed: (isTruckUploadFileAllowed: boolean) => ({
    type: "SET_TRUCK_UPLOAD_FILE_ALLOWED",
    isTruckUploadFileAllowed
  }),
  setTruckProcessDWPAllowed: (isTruckProcessDWPAllowed: boolean) => ({
    type: "SET_TRUCK_PROCESS_DWP_ALLOWED",
    isTruckProcessDWPAllowed
  }),
  setTruckProcessAdditionalServices: (
    isTruckProcessAdditionalServices: boolean
  ) => ({
    type: "SET_TRUCK_PROCESS_ADDITIONAL_SERVICES",
    isTruckProcessAdditionalServices
  }),
  setTruckApproveRejectionAllowed: (
    isTruckApproveRejectionAllowed: boolean
  ) => ({
    type: "SET_TRUCK_APPROVE_REJECTION_ALLOWED",
    isTruckApproveRejectionAllowed
  }),
  setTruckUpdateAssignmentAllowed: (
    isTruckUpdateAssignmentAllowed: boolean
  ) => ({
    type: "SET_TRUCK_UPDATE_ASSIGNMENT_ALLOWED",
    isTruckUpdateAssignmentAllowed
  }),
  setTruckSalesOrg: (truckSalesOrg: string) => ({
    type: "SET_TRUCK_SALES_ORG",
    truckSalesOrg
  })
};

export const reducers: Reducer<GeneralState> = (
  state: GeneralState | undefined,
  incomingAction: Action
): GeneralState => {
  if (state === undefined) {
    return defaultState;
  }

  const action = incomingAction as KnownAction;
  switch (action.type) {
    case "SET_VERIFY_INFORMATION":
      return {
        ...state,
        isVerifyInformationModal: action.isVerifyInformationModal
      };
    case "SET_ONLINE_STATUS":
      return { ...state, isOffline: action.isOffline };
    case "SET_PAGE_TITLE":
      return { ...state, pageTitle: action.pageTitle };
    case "SET_CHECK_SOF_REJECTION":
      return { ...state, sofViewRejection: action.sofViewRejection };

    case "SET_MARINE_EDIT_ACTIVITY_ALLOWED":
      return {
        ...state,
        isMarineEditActivityAllowed: action.isMarineEditActivityAllowed
      };
    case "SET_MARINE_EDIT_TIMESTAMP_ALLOWED":
      return {
        ...state,
        isMarineEditTimestampAllowed: action.isMarineEditTimestampAllowed
      };
    case "SET_MARINE_ADD_COMMENT_ALLOWED":
      return {
        ...state,
        isMarineAddCommentAllowed: action.isMarineAddCommentAllowed
      };
    case "SET_MARINE_DELETE_COMMENT_ALLOWED":
      return {
        ...state,
        isMarineDeleteCommentAllowed: action.isMarineDeleteCommentAllowed
      };
    case "SET_MARINE_UNDO_EXTENDED_ALLOWED":
      return {
        ...state,
        isMarineUndoExtendedAllowed: action.isMarineUndoExtendedAllowed
      };
    case "SET_MARINE_EDIT_ETA_ALLOWED":
      return {
        ...state,
        isMarineEditETAAllowed: action.isMarineEditETAAllowed
      };
    case "SET_MARINE_REJECT_LINEHANDLING_ALLOWED":
      return {
        ...state,
        isMarineRejectLineHandlingAllowed:
          action.isMarineRejectLineHandlingAllowed
      };
    case "SET_MARINE_UPLOAD_FILE_ALLOWED":
      return {
        ...state,
        isMarineUploadFileAllowed: action.isMarineUploadFileAllowed
      };
    case "SET_MARINE_PROCESS_DWP_ALLOWED":
      return {
        ...state,
        isMarineProcessDWPAllowed: action.isMarineProcessDWPAllowed
      };
    case "SET_MARINE_PROCESS_DWP_TRUCK_ONLY":
      return {
        ...state,
        isMarineDeliveryTruckOnly: action.isMarineDeliveryTruckOnly
      };
    case "SET_MARINE_PROCESS_ADDITIONAL_SERVICES":
      return {
        ...state,
        isMarineProcessAdditionalServices:
          action.isMarineProcessAdditionalServices
      };
    case "SET_MARINE_APPROVE_LINEHANDLING_ALLOWED":
      return {
        ...state,
        isMarineApproveLineHandlingAllowed:
          action.isMarineApproveLineHandlingAllowed
      };
    case "SET_MARINE_SALES_ORG":
      return { ...state, marineSalesOrg: action.marineSalesOrg };

    case "SET_TRUCK_EDIT_ACTIVITY_ALLOWED":
      return {
        ...state,
        isTruckEditActivityAllowed: action.isTruckEditActivityAllowed
      };
    case "SET_TRUCK_EDIT_TIMESTAMP_ALLOWED":
      return {
        ...state,
        isTruckEditTimestampAllowed: action.isTruckEditTimestampAllowed
      };
    case "SET_TRUCK_ADD_COMMENT_ALLOWED":
      return {
        ...state,
        isTruckAddCommentAllowed: action.isTruckAddCommentAllowed
      };
    case "SET_TRUCK_DELETE_COMMENT_ALLOWED":
      return {
        ...state,
        isTruckDeleteCommentAllowed: action.isTruckDeleteCommentAllowed
      };
    case "SET_TRUCK_UNDO_EXTENDED_ALLOWED":
      return {
        ...state,
        isTruckUndoExtendedAllowed: action.isTruckUndoExtendedAllowed
      };
    case "SET_TRUCK_UPLOAD_FILE_ALLOWED":
      return {
        ...state,
        isTruckUploadFileAllowed: action.isTruckUploadFileAllowed
      };
    case "SET_TRUCK_PROCESS_DWP_ALLOWED":
      return {
        ...state,
        isTruckProcessDWPAllowed: action.isTruckProcessDWPAllowed
      };
    case "SET_TRUCK_PROCESS_ADDITIONAL_SERVICES":
      return {
        ...state,
        isTruckProcessAdditionalServices:
          action.isTruckProcessAdditionalServices
      };
    case "SET_TRUCK_APPROVE_REJECTION_ALLOWED":
      return {
        ...state,
        isTruckApproveRejectionAllowed: action.isTruckApproveRejectionAllowed
      };
    case "SET_TRUCK_UPDATE_ASSIGNMENT_ALLOWED":
      return {
        ...state,
        isTruckUpdateAssignmentAllowed: action.isTruckUpdateAssignmentAllowed
      };
    case "SET_TRUCK_SALES_ORG":
      return { ...state, truckSalesOrg: action.truckSalesOrg };
    default:
      return state;
  }
};
